import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  updateCompanyAwayDetails(context, payload) {
    ApiService.setHeader();
    return ApiService.post("company/away/management/update", payload).then(
      (res) => {
        return res;
      }
    );
  },
};

export default {
  actions,
};
